// NOTICE: KAPTION-INTEGRATION - Durable WhatsApp message batches.
/* global axios */
const baseUrl = (accountId, conversationId) =>
  `/api/v1/accounts/${accountId}/conversations/${conversationId}/kaption_message_batches`;

export const getMessageBatch = (accountId, conversationId) =>
  axios.get(baseUrl(accountId, conversationId));
export const addMessageBatchFragment = (accountId, conversationId, data) =>
  axios.post(baseUrl(accountId, conversationId), data);
export const updateMessageBatch = (accountId, conversationId, batchId, data) =>
  axios.patch(`${baseUrl(accountId, conversationId)}/${batchId}`, data);
export const flushMessageBatch = (accountId, conversationId, batchId) =>
  axios.post(`${baseUrl(accountId, conversationId)}/${batchId}/flush`);
export const discardMessageBatch = (accountId, conversationId, batchId) =>
  axios.delete(`${baseUrl(accountId, conversationId)}/${batchId}`);
